export class CollegeMaster {
    public ID: number;
    public HashCode: string;
    public CollegeName: string;
    public CollegeCode: string;
    public TrustName: string;
    public Address: string;
    public MobileNo:string;
    public MailID:string;
    public Location:number;
    public Type:number;
    public StateID:number;
    public CityID:number;
    public Pincode:string;
    public YearID: number;
}